var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#5f6368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320-490v-170q0-25 17.5-42.5T380-720q25 0 42.5 17.5T440-660v170q0 25-17.5 42.5T380-430q-25 0-42.5-17.5T320-490Zm200-9v-321q0-25 17.5-42.5T580-880q25 0 42.5 17.5T640-820v321q0 30-18.5 45T580-439q-23 0-41.5-15T520-499ZM120-361v-139q0-25 17.5-42.5T180-560q25 0 42.5 17.5T240-500v139q0 30-18.5 45T180-301q-23 0-41.5-15T120-361Zm96 243q-26 0-36.5-24.5T188-186l164-164q11-11 26.5-12t27.5 10l114 98 224-224h-24q-17 0-28.5-11.5T680-518q0-17 11.5-28.5T720-558h120q17 0 28.5 11.5T880-518v120q0 17-11.5 28.5T840-358q-17 0-28.5-11.5T800-398v-24L550-172q-11 11-26.5 12T496-170l-114-98-138 138q-5 5-12.5 8.5T216-118Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashIcon);
export default __webpack_public_path__ + "static/media/cash-icon.12848871dd36b768b69497b15bbef498.svg";
export { ForwardRef as ReactComponent };